import {required} from "vuelidate/lib/validators";  
const StrBirimHarcamaLimit = {
    data() {
      return { 
        StrBirimHarcamaLimitData:{  
          Hesapkoduid:null,
          Yil:null,
          Birimid:null, 
          Ustlimit:null 
        },  
          FormDataType:{
            Hesapkoduid:{FieldName:"Hesapkoduid",Field:"combobox",FieldTitle:this.$t('StrBirimHarcamaLimit.AddEdit.Hesapkoduid'),ComboDataArray:[]},
            Yil:{FieldName:"Yil",Field:"combobox",FieldTitle:this.$t('StrBirimHarcamaLimit.AddEdit.Yil'),ComboDataArray:[]},
            Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:this.$t('StrBirimHarcamaLimit.AddEdit.Birimid'),ComboDataArray:[]}, 
            Ustlimit:{FieldName:"Ustlimit",Field:"checkbox",FieldTitle:this.$t('StrBirimHarcamaLimit.AddEdit.Ustlimit'),FieldType:"number"}  
          },
          
          Yillar:[
            {"id":"2021","value":"2021"},
            {"id":"2022","value":"2022"},
            {"id":"2023","value":"2023"},
            {"id":"2024","value":"2024"},
            {"id":"2025","value":"2025"},
            {"id":"2026","value":"2026"},
            {"id":"2027","value":"2027"},
            {"id":"2028","value":"2028"},
            {"id":"2029","value":"2029"},
            {"id":"2030","value":"2030"},

          ]
          
      } 
    },
    validations:{ 
      FormData: {
        Hesapkoduid: { required },  
        Yil: { required }, 
        Birimid: { required }, 
        Ustlimit: { required },  
      } 
  },
  created(){ 
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }

    this.ActionsGet({"Service":"OBirim","Page":Page}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Birimid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].BirimAdi})
        }    
    });  


    let Filter = "&Basamak=4";

    this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Hesapkoduid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " " + res.Data[i].Aciklama})
        }    
    }); 


    this.FormDataType.Yil.ComboDataArray=[];
    for (var i=0 ; i<this.Yillar.length; i++){
      this.FormDataType.Yil.ComboDataArray.push ({Id:this.Yillar[i].id,Value:this.Yillar[i].value})
    }


  }
}
export default StrBirimHarcamaLimit